module.exports = __webpack_public_path__ + "static/media/icon_extintor.45a683c8.svg";